import * as React from 'react';
import * as styles from './CardLabelList.css';

import { ICardLabel } from '../../types/newbuilding';
import clsx from 'clsx';
import { Label } from './Label';

interface ICardLabelListProps {
  labels: ICardLabel[] | null;
}

export const CardLabelList: React.FC<ICardLabelListProps> = ({ labels }) => {
  if (!labels || labels.length === 0) {
    return null;
  }

  return (
    <div className={styles['container']}>
      {labels.map((label, index) => {
        const hasDescription = Boolean(label.description);

        return (
          <div className={clsx(styles['label'], hasDescription && styles['label--clickable'])} key={index}>
            <Label label={label} />
          </div>
        );
      })}
    </div>
  );
};
